module.exports = __webpack_public_path__ + "img/23.ed198ee0.png";